import { salesForce as salesForceRoute } from '../../../data/enums/Route';

const breadCrumb = [salesForceRoute];

export { breadCrumb };
